<template>
    <div class="content">
        <h2>MEDICALLY NECESSARY</h2>
        <h4>A medical service, as determined by HMI which is (a) consistent with the diagnosis and customary medical treatment of the condition, (b) in accordance with the standards of managed care and good medical practice, (c) not for the convenience of the Member of the Affiliated Physician, (d) performed in the most cost effective manner required by the medical condition and (e) consistent with the terms and conditions of this Agreement.</h4>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.content {
  margin: auto;
  padding: 10px;
}
.content h2 {
  font-size: 16px;
  text-align: justify;
  color: #1b5e20;
}
.content h4 {
  font-weight: normal;
  font-size: 13px;
  text-align: justify;
  padding-left: 10px;
}
.content ul li {
  font-size: 13px;
  color: black;
  margin-top: 10px;
  list-style: none;
  text-align: justify;
}
@media (max-width: 599px) {
  .content {
    width: 90%;
    margin-top: 10px;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .content {
   
    width: 80%;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  .content {
    width: 100%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .content {
    width: 100%;
  }
}
</style>
